import { inject } from "@angular/core";
import { TaskService } from "../../../04_service/task.service";
import { CreateTaskMessageComponent } from "../messages/create-task-message/create-task-message.component";
import { AIComponentMessage } from "../../../03_model/ai-chat-message.model";
import { TaskModel } from "../../../03_model/task.model";
import { AITool } from "../../../03_model/ai-tool.interface";

export class CreateTaskTool implements AITool {

  taskService = inject(TaskService);

  tool_name = 'create_task';
  description = {
    "toolSpec": {
      "name": this.tool_name,
      "description": "Create a new task in the task management system. This tool gives the user a form to fill out the missing details of the task, such as title, deadline and priority before saving the task.",
      "inputSchema": {
        "json": {
          "type": "object",
          "properties": {
            "title": {
              "type": "string",
              "description": "The title of the task to create."
            },
            "deadline": {
              "type": "string",
              "description": "The deadline for the task in ISO 8601 format."
            },
            "priority": {
              "type": "string",
              "description": "The priority level of the task (e.g., low, medium, high)."
            },
          }
        }
      }
    }
  };

  async invoke({title, deadline, priority, description}: {title?: string, deadline?: string, priority?: string, description?: string}): Promise<AIComponentMessage> {
    return <AIComponentMessage>{
      type: 'component',
      role: 'user',
      component: CreateTaskMessageComponent,
      data: <Partial<TaskModel>>{ name: title, dueDate: deadline ? new Date(deadline) : null, summary: description, priority, submissionState: 'idle', errorMessage: null },
      contentForLLM: `Tool result: Displaying a form to let the user create a new task.`,
      requiresFollowUp: false,
    };
  }
}
